// External Imports
import { h } from 'preact';
import { Layout as DSLayout, pxToRem, styled } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Local Variables
const desktopBreakpoint = parseInt(tokens.viewports.breakpoints.medium, 10);
const siteMaxWidth = 1246;
const Layout = styled(DSLayout)`
  width: 100%;
  @media (min-width: ${pxToRem(desktopBreakpoint)}) {
    max-width: ${pxToRem(siteMaxWidth)};
  }
`;

function LayoutWithSiteMaxWidth({ children, ...props }) {
  return (
    // This acts a generic wrapper for Layout, so passing down props is required.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Layout {...props}>{children}</Layout>
  );
}

export { LayoutWithSiteMaxWidth, siteMaxWidth };
